export default "__VITE_ASSET__BLC9finF__"